class CBBOView {

  constructor(div_id, table_id) {
    var self = this;
    this.div_id = div_id;
    this.table_id=table_id;
    this.chart = document.getElementById(div_id);
    this.setupChart();
    window.addEventListener("resize", function(){
    Plotly.Plots.resize(self.chart);
    });
    $('#id_currency_pair, #id_exchanges, #id_market_data_exchanges').on('change', function() {
      console.log("cbbo currency change");
      self.chart.data[0].x=[]
      self.chart.data[0].y=[]
      self.chart.data[0].text=[]

      self.chart.data[1].x=[]
      self.chart.data[1].y=[]
      self.chart.data[1].text=[]

      Plotly.restyle(self.chart);
      self.refresh();
      self.setupChart();
    });


  }

  getParams() {
    this.exchanges = new Set($('#id_market_data_exchanges').val());
    this.currency_pair = $('#id_currency_pair').val();
  }

  setupChart() {


   Plotly.plot(this.chart, [
      {
         "type":"scatter",
         "x": [],
         "y": [],
         "text": [],
         "name":"Bids",
         "mode":"lines+markers",
         "xaxis":"x1",
         "yaxis":"y1"
      },
      {
         "type":"scatter",
         "x":[],
         "y": [],
         "text": [],
         "name":"Asks",
         "mode":"lines+markers",
         "xaxis":"x1",
         "yaxis":"y1"
      }
   ],
   {
      "xaxis1":{
         "domain":[
            0.0,
            1.0
         ],
         "anchor":"y1",


      },
      "yaxis1":{
         "domain":[
            0.0,
            1.0
         ],
         "anchor":"x1",
         "tickangle": 45,
      },
      "margin":{
         "l":40,
         "r":10,
         "b":20,
         "t":10
      },
      "legend":{

         "orientation": "h"
      },
      "autosize":true
   },
   {
      "editable":false,
      "showLink":false,
      "modeBarButtonsToRemove":[
         "sendDataToCloud"
      ],
      "displaylogo":false
   })

    // Plotly.plot( this.chart, [{
    //
    //           	x: [],
    //           	y: [ }], {
    //           	margin: { t: 0 } }
    //
    //
    //           );
  }

  refresh() {
    if (this.sock) {
      this.sock.close();
    }
    this.connect();

  }
  connect() {
    var self = this;
    var ws_scheme = window.location.protocol == "https:" ? "wss" : "ws";
    var host = window.location.host;
    var ws_path = ws_scheme + '://' + host + "/api/streaming/cbbo/"
    console.log(ws_path);
    this.sock = new ReconnectingWebSocket(ws_path);
    var md_exchanges = new Set($('#id_market_data_exchanges').val());
    this.exchanges = new Set($('#id_exchanges').val());
    md_exchanges.forEach(this.exchanges.add, this.exchanges);

    this.currency_pair = $('#id_currency_pair').val();
    if (!this.currency_pair) {
      return
    }
    console.log(this.currency_pair);
    this.setupOnMessage();
    this.sock.onopen = function() {
     console.log("Connected!");
     //$('#sensor').text("Connected!");
     var data = {
         currency_pair: self.currency_pair,
         size_filter: 0,
         sample: 0.5
       };
     self.sock.send(JSON.stringify(data));
    };

  }

  drawTable(bids, asks) {

    var bidClass = function(idx) {
      if(!idx) { return "style='background: #20a8d8; font-weight: bold; color:#fff;'"}
      return ""
    }
    var askClass = function(idx) {
      if(!idx) { return "style='background: #fabb3d; font-weight: bold; color:#fff;'"}
      return ""
    }
    var trimdecimal = function(n) {
      return n.replace(/(\.[0-9]*[1-9])0+$|\.0*$/,'$1');

    }

    var style = document.createElement('style');
    document.head.appendChild(style);
    style.appendChild(document.createTextNode(`
      .bestBid {background: #20a8d8; font-weight: bold; color:#fff;}
      .bestAsk {background: #fabb3d; font-weight: bold; color:#fff;}
      `));

    const bids_table = `
    <thead>
    <tr><th style='text-align:right' colspan=3>Bids</th>  <td>&nbsp;</td> <th colspan=3>Asks</th> </tr>
    <tr><td style="width:auto;">Exchange</td><td>Quantity</td><td>Price</td> <td>&nbsp;</td> <td>Price</td><td style="text-align:right;">Quantity</td><td style="text-align:right;">Exchange</td> </tr>
    </thead>
    <tbody>
        ${bids.map((bid, idx) => `<tr>
          <td style="width:auto;" class="${idx ? ``: `bestBid`}">${bid.exchange}</td><td class="${idx ? ``: `bestBid`}">${trimdecimal(parseFloat(bid.qty).toPrecision(7))}</td><td class="${idx ? ``: `bestBid`}">${trimdecimal(parseFloat(bid.price).toPrecision(7))}</td>
          ${idx ? `<td>&nbsp;</td>` : `<td style="text-align:center;"> ${parseFloat(parseFloat(asks[idx].price - bid.price).toPrecision(7)).toString()} </td>`}

          <td class="${idx ? ``: `bestAsk`}">${trimdecimal(parseFloat(asks[idx].price).toPrecision(7))}</td><td class="${idx ? ``: `bestAsk`}" style="text-align:right;">${trimdecimal(parseFloat(asks[idx].qty).toPrecision(7))}</td><td class="${idx ? ``: `bestAsk`}" style="text-align:right;">${asks[idx].exchange}</td>



          </tr>
          `).join('')}
    </tbody>
    `;
    $('#cbboTable').html(bids_table);
    // const asks_table = `
    // <thead>
    // <tr><td>Price</td><td>Quantity</td><td>Exchange</td></tr>
    // <tbody>
    //     ${bids.map(bid => `<tr><td>${bid.price}</td><td>${bid.quantity}</td><td>${bid.exchange}</td></tr>`).join('')}
    // </tbody>
    // `;
  }

  setupOnMessage() {
    var self = this;
    this.sock.onmessage = function(data) {
        var message = JSON.parse(data.data);
        //console.log(message);

        var bids = message.bids.filter(function(obj) {
        return self.exchanges.has(obj.exchange);
        });

        var asks = message.asks.filter(function(obj) {
        return self.exchanges.has(obj.exchange);
        });

        Plotly.extendTraces(self.chart, {
        x: [[message.generated_timestamp]],
        y: [[bids[0].price]],
        text: [[bids[0].exchange + ": QTY: " + bids[0].qty]]
      }, [0], 200);

      Plotly.extendTraces(self.chart, {
        x: [[message.generated_timestamp]],
        y: [[asks[0].price]],
        text: [[asks[0].exchange + ": QTY: " + asks[0].qty]]
      }, [1], 200);
      self.drawTable(bids, asks);
    }
  }

}
